import 'jquery-dateformat/dist/jquery-dateformat.js'
import {format, isFuture, isPast, isToday} from 'date-fns';
import {de, enUS as en, nl} from 'date-fns/locale';

jQuery(document).ready(function ($) {

  // eslint-disable-next-line no-undef
  const availabilityPerDate = availibilityperdate;

  // eslint-disable-next-line no-undef
  const availableDates = uniqueeventdates;
  let firstFutureDateIndex = 0;

  // eslint-disable-next-line no-undef
  const availableSpots = spots;

  // eslint-disable-next-line no-undef
  const pllLang = pll;

  // eslint-disable-next-line no-undef
  const limitedThreshold = limitedtreshold;

  // eslint-disable-next-line no-undef
  const translations = translationdata;

  /**
   * Validate that all dates are in the future.
   * This should be done server-sided however the caching system allows 30 minutes of overlap.
   * Thus this fallback check was introduced.
   */
  $.each(availableDates, function (index, value) {
    if (isFutureDate(value)) {
      firstFutureDateIndex = index;
      return false;
    }
  });

  /**
   * This function checks is a specific date is available. Based on the localized array.
   *
   * @author  Nils Ringersma
   * @since   1.0.0
   */
  function available(date) {

    const ymd = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate() + 0)).slice(-2);
    const classes = [];
    const numberSpots = parseInt(availabilityPerDate[ymd]);
    const hasAnyAvailable = numberSpots > 0;
    if ($.inArray(ymd, availableDates) != -1) {
      classes.push(hasAnyAvailable ? 'available' : 'sold-out');
    }

    if (isPast(date) || isToday(date)) {
      classes.push(isToday(date) ? 'ui-datepicker--today' : 'ui-datepicker--past', 'disabled');

      return [numberSpots === 0, classes.join(' ')];
    }

    if ($.inArray(ymd, availableDates) !== -1) {
      return [true, classes.join(' ')];
    }

    return [false, 'disabled'];
  }

  /**
   * Locales for Datepickers.
   *
   * @author  Nils Ringersma
   * @since   1.0.0
   */
  $.datepicker.regional['nl'] = {
    closeText: 'Sluiten',
    currentText: 'Vandaag',
    monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
      'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
      'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
    dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    weekHeader: 'Wk',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
  };

  $.datepicker.regional['de'] = {
    closeText: 'Schließen',
    currentText: 'Heute',
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
      'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    weekHeader: 'KW',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
  };

  $.datepicker.setDefaults($.datepicker.regional[pllLang]);

  /**
   * Initialize the datepicker.
   *
   * Initial date is the first day of the month.
   *
   * @author  Nils Ringersma
   * @since   1.0.0
   */
  $('#datepicker').datepicker({
    minDate: 1,
    maxDate: '+1Y',
    beforeShowDay: available,
    altField: '#dateHidden',
    altFormat: 'yy-mm-dd',
    dateFormat: 'yy-mm-dd',
    prevText: '<span class="btn btn--small btn--primary"><i class="far fa-arrow-left"></i></span>',
    nextText: '<span class="btn btn--small btn--primary"><i class="far fa-arrow-right"></i></span>',
    onSelect: populate,
  }).datepicker('setDate', availableDates[firstFutureDateIndex]);

  // Populate the first available day on page load.
  populate(availableDates[firstFutureDateIndex]);

  /**
   * This function populates the div with events.
   *
   * @author  Nils Ringersma
   * @since   1.0.0
   *
   * @modified Mitch Hijlkema
   */
  function populate(date) {

    const dateIndex = availableDates.indexOf(date);
    const calendarHTMLContainer$ = jQuery('#experience-calendar__items');
    // Clear events div to append data.
    calendarHTMLContainer$.html('');
    let title = format(new Date(`${date}`), 'EEEE d MMMM', {locale: getDatFnsLang()});
    /**
     * Create a header element with the required buttons and title.
     *
     * The button click bubbles up to the body to only bind the event once.
     * @type {string}
     */
    let html = `
<header class="d-md-flex experience-calender__header">
  <h2>${title}</h2>
  <div class="d-flex external-calendar-buttons">
    <span class="btn btn--small btn--primary btn--rounded" data-action="prevDay" ${dateIndex === 0 ? 'disabled' : ''}><i class="far fa-arrow-left"></i></span>
    <span class="ml-1 btn btn--small btn--primary btn--rounded" data-action="nextDay" ${dateIndex >= availableDates.length - 1 ? 'disabled' : ''}><i class="far fa-arrow-right"></i></span>
  </div>
</header>`;

    const availableSlotsHtml = [];
    const soldOutSlotsHtml = [];
    let soldOutLabel = `
    <h3>${translations.notification}</h3>
    <p>${translations.outofstock}</p>`;

    $.each(availableSpots[date], function (key, slot) {

      const timeslot = slot['time'] !== '00:00' ? `${slot['time']} ${translations.am}` : '';

      let availableClass = '';
      let buttonUrl = slot['product_url'];
      let buttonHtml = `<a href="${buttonUrl}" target="_blank" class="btn btn--action btn--fw">${translations.booknow}</a>`

      if (slot['available'] === 0) {
        availableClass = ' event--sold-out';
        buttonHtml = `<span class="btn btn--action btn--fw"
data-action="notify"
data-date="${date}"
data-event="${slot['product_name']}">${translations.notifyme}</span>`;
      }

      if (slot['available'] > 0 && slot['available'] < limitedThreshold) {
        availableClass = ' event--limited-spots';
      }

      const shouldShowLowStockMessage = available => available > 0 && available <= 5;
      const shouldShowTimeSlot = time => time !== '';

      const htmlWrapper = `
<div class="event ${availableClass}">
  <div class="event__header">
    <a href="${slot['rp_permalink']}" class="event__title">${slot['product_name']}</a>
    <div class="event__time-wrapper">
        ${shouldShowTimeSlot(timeslot) ? `<p class="event__time">Start ${timeslot}</p>` : ''}
        ${shouldShowLowStockMessage(slot['available']) ? `<p class="event__time">${translations.lastspots}</p>` : ''}
    </div>
    <p class="event__price">&euro;${slot['product_price']}</p>
  </div>
  <div class="event__button-wrapper ${availableClass}">${buttonHtml}</div>
</div>`;

      // Sort sold out experiences to lower section.
      if (slot['available'] === 0) {
        soldOutSlotsHtml.push(htmlWrapper);
      } else {
        availableSlotsHtml.push(htmlWrapper);
      }
    });

    if (availableSlotsHtml.length > 0) {
      html += availableSlotsHtml.join('');
    } else {
      soldOutLabel = `<p>${translations.noexp}</p>`;
    }

    if (soldOutSlotsHtml.length > 0) {
      soldOutSlotsHtml.unshift(soldOutLabel);
      html += soldOutSlotsHtml.join('');
    }

    calendarHTMLContainer$.append(html);
  }

  /**
   * This function checks if a date (Y-m-d) is in the future.
   *
   * @param date
   *
   * @returns {boolean}
   */
  function isFutureDate(date) {
    date = date.split('-');

    date = new Date(date[0], date[1] - 1, date[2]);
    return isToday(date) || isFuture(date);
  }

  function setNextAvailableDate() {
    const picker = $('#datepicker');
    const date = format(picker.datepicker('getDate'), 'yyyy-MM-dd');
    const currIndex = availableDates.indexOf(date);

    if ((currIndex + 1) in availableDates) {
      picker.datepicker('setDate', availableDates[currIndex + 1])
      return availableDates[currIndex + 1];
    }

    // Fallback return to the first available date.
    picker.datepicker('setDate', availableDates[0]);

    return availableDates[0];
  }

  /**
   * Return the date to use in populate.
   *
   * @returns {*}
   */
  function setPreviousAvailableDate() {
    const picker = $('#datepicker');
    const date = format(picker.datepicker('getDate'), 'yyyy-MM-dd');
    const currIndex = availableDates.indexOf(date);

    if (currIndex > 0) {
      picker.datepicker('setDate', availableDates[currIndex - 1]);
      return availableDates[currIndex - 1];
    }

    picker.datepicker('setDate', availableDates[availableDates.length - 1]);

    return availableDates.length - 1;
  }

  function getDatFnsLang() {
    switch (pllLang) {
      case 'nl':
        return nl;
      case 'de':
        return de;
      case 'en':
      default:
        return en;
    }
  }

  document.body.addEventListener('click', e => {
    if (e.target.dataset.action === null) {
      return;
    }

    if (e.target.dataset.action === 'nextDay') {
      populate(setNextAvailableDate());
    }

    if (e.target.dataset.action === 'prevDay') {
      populate(setPreviousAvailableDate());
    }

    const overlay = document.querySelector('#page-overlay');

    if (e.target.dataset.action === 'notify') {
      overlay.classList.add('show-modal');
      overlay.style.pointerEvents = 'none';
      document.querySelector('html').style.overflow = 'hidden';
      $('.js-set-experience').val(e.target.dataset.event).trigger('change');
      $('.js-set-experience-date').val(e.target.dataset.date).trigger('change');
      document.querySelector('.experience-calender__popup').setAttribute('open', true);
    }

    if (e.target.dataset.action === 'close-modal' || e.target.getAttribute('id') === 'page-overlay') {
      overlay.classList.remove('show-modal');
      overlay.style.pointerEvents = '';
      document.querySelector('html').style.overflow = '';
      document.querySelector('.nf-response-msg').style.display = '';
      document.querySelector('.experience-calender__popup').removeAttribute('open');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/experience-calendar.js